/*
 * @Author: LQ
 * @Date: 2022-06-08 08:54:06
 * @LastEditors: HRD
 * @LastEditTime: 2022-11-30 09:45:22
 * @FilePath: \scm-pc\src\official\store\modules\navigation.js
 * @Description:
 *
 * Copyright (c) 2022 by LQ/量迅, All Rights Reserved.
 */
import { findPath, findNode, filter } from '@/utils/helper/treeHelper';
import { useGlobSetting } from '@/hooks/setting';
import { cloneDeep } from 'lodash-es';
const { previewUrl } = useGlobSetting();

const state = () => ({
  currentPage: {},
});

const getters = {
  /**
   * @description: 获取所有树状列表
   * @return {Array}
   */
  getNavigationAllTree: (_state, _getters, rootState) => {
    return cloneDeep(rootState.app.listNavigation || []);
  },
  /**
   * @description: 获取导航树状列表
   * @return {Array}
   */
  getNavigationTree: (_state, getters) => {
    return getters.getNavigationAllTree.filter((item) => item.type === 1);
  },

  getNavigationOnlyShow: (_state, getters) => {
    return filter(getters.getNavigationTree, (node) => !node.isHide, {
      children: 'childrenList',
      stopOnParent: true,
    });
  },

  /**
   * @description: 通过navigationId获取页面
   * @return {*}
   */
  getNavigationPage: (_state, getters) => {
    return (navigationId) => {
      return findNode(
        getters.getNavigationTree || [],
        (node) => {
          return `${node.id}` === `${navigationId}`;
        },
        { children: 'childrenList' }
      );
    };
  },

  /**
   * @description: 通过navigationId获取页面Id
   * @return {*}
   */
  getNavigationPageId: (_state, getters) => {
    return (navigationId) => {
      return getters.getNavigationPage(navigationId)?.pageId;
    };
  },

  /**
   * @description: 通过pageId获取navigationId
   * @return {*}
   */
  getPageNavigationId: (_state, getters) => {
    return (pageId) => {
      return findNode(
        getters.getNavigationTree || [],
        (node) => {
          return `${node.pageId}` === `${pageId}`;
        },
        { children: 'childrenList' }
      )?.id;
    };
  },

  getLinkTree: (_state, getters) => {
    return getters.getNavigationAllTree.filter((item) => item.type === 2);
  },
  getLinkTreeOnlyShow: (_state, getters) => {
    // return getters.getNavigationAllTree.filter((item) => item.type === 2);

    return filter(getters.getLinkTree, (node) => !node.isHide, {
      children: 'childrenList',
    });
  },

  /**
   * @description: 获取当前页对于的路由ID
   * @return {*}
   */
  getCurrentNavigationId: (state) => {
    return state.currentPage?.regionNavigationId;
  },
  /**
   * @description: 通过pageId获取当前页面路由名称
   * @return {*}
   */
  getCurrentNavigationName(_state, getters) {
    const pageId = getters.getCurrentPage?.id;
    return findNode(
      getters.getNavigationTree || [],
      (node) => {
        return `${node.pageId}` === `${pageId}`;
      },
      { children: 'childrenList' }
    )?.name;
  },

  getCurrentPage: (state) => {
    return state.currentPage;
  },

  getBreadcrumbs: (_state, getters) => {
    return findPath(
      getters.getNavigationTree,
      (node) => {
        return node.id === getters.getCurrentNavigationId;
      },
      { children: 'childrenList' }
    );
  },

  getCurrentPageIsBigScreen(state) {
    return ~~state.currentPage?.type === 4;
  },

  getShowSwiper(state) {
    return ~~state.currentPage?.showSwiper;
  },
  getShowHeader(state) {
    return state.currentPage?.showHeader === 0 ? 0 : 1;
  },
  getShowFooter(state) {
    return state.currentPage?.showFooter === 0 ? 0 : 1;
  },
  getShowFloat(state) {
    return state.currentPage?.showFloat === 0 ? 0 : 1;
  },
  getPageWidth(state) {
    return ~~state.currentPage?.width || 1080;
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, page) => {
    state.currentPage = cloneDeep(page);
  },
};

const actions = {
  setCurrentPage: ({ commit }, page) => {
    commit('SET_CURRENT_PAGE', page);
    commit('page/SET_PAGE_OBJECT', page, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
